import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g id="Logo" transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="M21.5 21 H30 V40 L50 21 L60 21 L35 45 L60 69 L50 69 L30 50 L30 69 L21.5 69 L21.5 21"
          fill="#FEE715FF"
        />
        <polygon
          id="Shape"
          stroke="#FEE715FF"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
